export default "__VITE_ASSET__21641345__"